export default __webpack_public_path__ + "static/media/img9.a216fd15.png";